export default __webpack_public_path__ + "6aebbaaad4fcaa5e6e6387e8e053de83.jpg";